<template>
  <div class="requestshipment">
    <FormWarehouse />
  </div>
</template>
<script>
import FormWarehouse from '@/components/warehouse/FormWarehouse'

export default {
  name: 'warehouse',
  components: {
    FormWarehouse
  },
  data () {
    return {}
  }
}
</script>



// WEBPACK FOOTER //
// src/view/warehouse/index.vue